import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/requester-dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('./master/master.module').then(m => m.MasterModule)
  },
  {
    path: 'landing',
    loadChildren: () => import('./landing-root/landing-root.module').then(m => m.LandingRootModule)
  },
  {
    path:'**',
    redirectTo:'requester-dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
